import { isNull } from './is-null.js';
import { isObject } from './is-object.js';
import { isUndefined } from './is-undefined.js';

/**
 * @description
 * Checks if a `value` is `empty`.
 * `{}, null, undefined, [] ` is empty; `0, false` is not empty.
 *
 * @example
 * ``` ts
 * isEmpty(undefined);
 * // => true
 * isEmpty([]);
 * // => true
 * isEmpty({});
 * // => true
 * isEmpty(null);
 * // => true
 * isEmpty(0);
 * // => false
 * isEmpty(false);
 * // => false
 * ```
 *
 * @param value The value to check.
 * @returns Returns true if value is a `empty`, else false.
 *
 * @docsCategory preference/lang
 * @codeFilter is-empty
 */
export const isEmpty = (value): boolean => {
  if (isUndefined(value)) {
    return true;
  }
  if (isNull(value)) {
    return true;
  }
  if (isObject(value)) {
    return Object.keys(value).length <= 0;
  }
  return !String(value);
};
